// extracted by mini-css-extract-plugin
module.exports = {"paymentMethods":"styles_paymentMethods__2Fop9"};